module.exports = __webpack_public_path__ + "static/scale-model-of-walk-sf-tours-in-san-francisco-california-8f8ceba7584ea0db4e7d8f8b7a912794.png";